import { OrderStatusViewModel } from '@spa/components/organisms/mypage/order/model/order-status-view'
import CvsStatusView from '@spa/components/organisms/mypage/order/state/CvsStatusView.vue'
import { Order } from '@spa/store/modules/orderHistory/types'
import Vue, { VueConstructor } from 'vue'

/**
 * 支払問題の表示ロジック
 *
 * 将来的な拡張について：
 * - 現在は「支払問題」に特化しているが、より一般化できる可能性がある
 * - e.g. 再決済の表示、住所不備による配送不可のお知らせなど
 * - SEE: https://github.com/Everforth/growthpalette-front/issues/8721#issuecomment-3609620505
 * - これらとの統合や、より広い責務への拡張については今後の検討課題
 * - SEE: https://github.com/Everforth/growthpalette-front/pull/8736#pullrequestreview-3553905437
 */

/**
 * 支払問題を提示するべきかどうかを判定
 *
 * @param order
 * @returns true: 支払問題を提示するべき, false: 提示不要
 */
export function shouldShowPaymentProblemState(order: Order): boolean {
  const paymentMethod = order.payment.method.kind
  const orderStatus = order.salesOrderStatus

  // コンビニ決済 × 決済待ち
  if (paymentMethod === 'cvs-number' && orderStatus === 'payment-requested') {
    return true
  }

  return false
}

/**
 * 支払問題を提示するコンポーネントを取得
 *
 * @param order
 * @param statusView
 * @returns 提示すべきコンポーネント
 */
export function getPaymentProblemStateView(
  order: Order,
  statusView: OrderStatusViewModel
): VueConstructor {
  return Vue.extend({
    name: 'CvsPaymentProblemView',
    components: { CvsStatusView },
    data: () => ({
      order,
      statusView,
    }),
    template: '<cvs-status-view :order="order" :status-view="statusView" :show-status-label="false" />',
  })
}
